import React from "react";
import { CircleCheck, CircleX } from "lucide-react";
import { Icon } from "src/components/icons/Icon";
import { IOrganizationUserTrainingCourseSummary } from "src/@types/ImpiricaPlatformApi";
import styles from "./TrainingSummaryHeaderCourse.module.scss";

const TrainingSummaryHeaderCourse: React.FC<
	IOrganizationUserTrainingCourseSummary
> = ({ title, courseComplete }) => {
	return (
		<div className={styles.container}>
			<p className={styles.title}>{title}</p>
			{courseComplete ? (
				<Icon
					icon={CircleCheck}
					size="lg"
					className={styles.icon}
					color="#52c41a"
				/>
			) : (
				<Icon
					icon={CircleX}
					size="lg"
					className={styles.icon}
					color="#eb2f96"
				/>
			)}
		</div>
	);
};

export default TrainingSummaryHeaderCourse;
